import styled from "styled-components";
import { Modal as BaseModal } from "@wrstudios/components";
import BaseButton from "../../common/Button";
import BaseTitle from "../../common/Title";
import BaseTip from "../../common/Tip";

export const Container = styled.div`
  margin: 3rem 0;
`;

export const Title = styled(BaseTitle)`
  margin-bottom: 3rem;
  text-align: center;
`;

export const Section = styled.div`
  margin: 6rem 0 2rem;

  &:first-child {
    margin-top: 0;
  }

  &:last-child {
    margin-bottom: 0;
  }
`;

export const SectionNotifications = styled(Section)`
  max-width: 46rem;
  margin-left: auto;
  margin-right: auto;
`;

export const Header = styled.h2`
  font-size: 2.4rem;
  font-weight: 400;
  line-height: 3.3rem;
  margin: 0 0 2rem;
  color: ${({ theme }) => theme.styleGuide.colors.gray[900]};
  text-align: center;
`;

export const Text = styled.p`
  font-size: ${({ normal }) => (normal ? "inherit" : "1.3rem")};
  line-height: ${({ normal }) => (normal ? "2.4rem" : "2rem")};
  margin-top: 2rem;
  text-align: ${({ align = "left" }) => align};
`;

export const ImageContainer = styled.span`
  display: block;
  max-width: 36rem;
  margin: 2rem auto;
  border-radius: 0.5rem;
  box-shadow: ${({ theme }) => theme.styleGuide.shadows.raised};
  transition: box-shadow 0.2s;
  overflow: hidden;

  &:hover {
    box-shadow: ${({ theme }) => theme.styleGuide.shadows.overlay};
  }
`;

export const Tip = styled(BaseTip)`
  max-width: 40rem;
  color: ${({ theme }) => theme.styleGuide.colors.gray[600]};
`;

export const Grid = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  margin: -1rem;
`;

export const Cell = styled.div`
  padding: 1rem;

  ${({ theme }) => theme.media.md`
    width: 50%;
  `}
`;

export const ShareButton = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 13rem;
  height: 12rem;
  padding: 0.24rem;
  box-shadow: ${({ theme }) => theme.styleGuide.shadows.raised};
  border-radius: 0.5rem;
  background-color: ${({ theme }) => theme.styleGuide.colors.white};
  color: ${({ theme }) => theme.styleGuide.colors.gray[800]};
  transition: box-shadow 0.2s;
  text-decoration: none;
  text-align: center;
  cursor: pointer;

  &:hover {
    box-shadow: ${({ theme }) => theme.styleGuide.shadows.overlay};
  }

  ${({ theme }) => theme.media.md`
    width: 100%;
  `}
`;

export const ShareButtonIcon = styled.span`
  display: block;
  text-align: center;

  svg {
    width: 3.6rem;
    height: 3.6rem;
  }
`;

export const ShareButtonIconEmbed = styled(ShareButtonIcon)`
  svg {
    fill: ${({ theme }) => theme.styleGuide.colors.attract[500]};
  }
`;

export const ShareButtonText = styled.span`
  display: block;
  margin-top: 1.5rem;
`;

export const Badge = styled.span`
  display: inline-block;

  font-weight: 700;
  font-size: 0.9rem;
  line-height: 1.25;
  padding: 0.1rem 0.3rem;
  text-transform: uppercase;
  border-radius: 0.2rem;
  color: ${({ theme }) => theme.styleGuide.colors.white};
  background-color: ${({ theme }) => theme.styleGuide.colors.attract[500]};
  text-transform: uppercase;
`;

export const ListContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const List = styled.ul`
  margin: 0;
  padding: 0;
  list-style: none;
`;

export const ListItem = styled.li`
  margin-bottom: 1rem;

  &:last-child {
    margin-bottom: 0;
  }

  svg {
    width: 1.8rem;
    height: 1.8rem;
    margin-right: 1rem;
    color: ${({ theme }) => theme.styleGuide.colors.attract[500]};
  }
`;

export const TryAttract = styled.a`
  display: inline-flex;
  align-items: center;
  color: ${({ theme }) => theme.styleGuide.colors.attract[500]};
  text-decoration: none;

  svg {
    margin-left: 0.4rem;
    fill: ${({ theme }) => theme.styleGuide.colors.attract[500]};
  }
`;

export const ModalContent = styled(BaseModal.Content)`
  width: 100%;
  max-width: 60rem;
`;

export const ModalFooter = styled(BaseModal.Footer)`
  text-align: right;
`;

export const Copy = styled(BaseButton)`
  margin-top: 0.5rem;
  border: 0;

  &:focus:not(:disabled),
  &:active:not(:disabled) {
    border: 0;
    box-shadow: none;
  }
`;
